import { get } from 'lodash-es';

function mapUsersAvatars(users) {
  return users.reduce((avatars, user) => avatars.set(user.id, user.avatar), new Map());
}

/**
 * Helper function to prepare avatars for the HubAvatar component
 *
 * @param {Object} Array of users | must have {:id, avatar: {:thumb, :speck, :normal} }
 * @returns Map object. Each entry has the user id as the key and the avatar object { :thumb, :speck, :normal } as the value.
 * Used by the HubAvatar component
 **/

export const createUsersAvatarsMixin = (key) => ({
  computed: {
    usersAvatars() {
      return mapUsersAvatars(get(this, key));
    },
  },
});
